import ImageBlock from './ImagePageItem';
import TextBlock from './TextPageItem';
import VideoBlock from './VideoPageItem';
import { type PageItem, PageItemType } from '@/types';
import { YoutubePageItem } from './YoutubePageItem';
import BookingListPageItem from './BookingListPageItem';
import BookingPageItem from './BookingPageItem';
import CarouselBlock from './CarouselPageItem';
import { EmbeddedPageItem } from './EmbeddedPageItem';
import { usePlaybackContext } from '../PlaybackContext';

interface IBlockProps {
  pageItem: PageItem;
  rotation?: number;
  isActive?: boolean;
}

const blocks = {
  [PageItemType.Image]: ImageBlock,
  [PageItemType.Text]: TextBlock,
  [PageItemType.Youtube]: YoutubePageItem,
  [PageItemType.BookingList]: BookingListPageItem,
  [PageItemType.Booking]: BookingPageItem,
  [PageItemType.Carousel]: CarouselBlock,
  [PageItemType.Embedded]: EmbeddedPageItem,
} as const;

export function PageItem({ pageItem, rotation, isActive }: IBlockProps) {
  const { type, settings, pageId } = pageItem;
  const { useFullVideoDuration, onVideoEnded } = usePlaybackContext();

  if (type === PageItemType.Video) {
    const parsedSettings = typeof settings === 'string' ? JSON.parse(settings) : settings;

    return (
      <VideoBlock
        {...parsedSettings}
        rotation={rotation}
        isActive={isActive}
        loop={!useFullVideoDuration}
        onEnded={useFullVideoDuration ? onVideoEnded : undefined}
      />
    );
  }

  const BlockComponent = blocks?.[type as keyof typeof blocks];

  if (!BlockComponent) return <span>Unknown block {type}</span>;

  if (typeof settings === 'string') {
    return <BlockComponent {...JSON.parse(settings)} pageId={pageId} rotation={rotation} isActive={isActive} />;
  }

  return <BlockComponent {...({ ...settings } as any)} pageId={pageId} rotation={rotation} isActive={isActive} />;
}
